import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logo from "../../assets/navLogo.svg";
import './Navbar.css';

function Navbar() {
  const navigate = useNavigate();
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);

    const user = localStorage.getItem('user');
    if (user) {
      const parsedUser = JSON.parse(user);
      setUserRole(parsedUser.role);
    } else {
      setUserRole(null); // Set userRole to null if no user is logged in
    }
  }, []);

  const toggleDropdown = () => setDropdownOpen(!isDropdownOpen);

  const handleLogout = () => {
  localStorage.clear(); // This removes all keys from localStorage
  setUserRole(null);
  navigate('/');
};


  const handleLinkClick = () => {
    setDropdownOpen(false);
  };


  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <Link to="/">
          <img src={logo} alt="Logo" className="responsive-logo" />
        </Link>
      </div>
      <div className="menu-icon" onClick={toggleDropdown}>
        &#9776; {/* Unicode for hamburger icon */}
      </div>
      <ul className="navbar-nav">
        {userRole === 'admin' ? (
          <>
            <li className="nav-item">
              <Link className="nav-link" to="/admin-dashboard">Home</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/add-questionsBooks">Add Questions</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/import-questions">Import Questions</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/manage-access">Manage Students</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/coupon-management">Manage Coupon</Link>
            </li>
             <li className="nav-item">
              <Link className="nav-link" to="/admin/add-teacher">Manage Teachers</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/admin/writing-tests">Assign Writings</Link>
            </li>
            <li className="nav-item">
              <button className="font-semibold bg-red-600 px-6 py-3 rounded-md text-center text-white hover:bg-red-500" onClick={handleLogout}>Logout</button>
            </li>
          </>
        ) : userRole === 'student' ? (
          <>
            <li className="nav-item">
              {/* <Link className="nav-link" to="/student-dashboard">Student Dashboard</Link> */}
              <Link className="nav-link" to="/new-student-dashboard">Student Dashboard</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/profile">My Profile</Link>
            </li>
            <li className="nav-item">
              <button className="font-semibold bg-red-600 px-6 py-3 rounded-md text-center text-white hover:bg-red-500" onClick={handleLogout}>Logout</button>
            </li>
          </>
        ) : (
          <>
            {/* <li className="nav-item">
              <Link className="nav-link" to="/landing">Home</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/about-us">About Us</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/pricing">Pricing</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/exam-selection">Free Assessment</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/faqs">FAQs</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/contact-us">Contact Us</Link>
            </li>
            <li className="nav-item login-item">
              <Link className="font-semibold bg-yellow-600 px-6 py-3 rounded-md text-center text-white hover:bg-yellow-500" to="/login" onClick={handleLinkClick}>Log In/Sign up</Link>
            </li> */}
            <li className="nav-item">
              <Link className="nav-link" to="/landing">Home</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/oc-journey">OC Journey</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/selective-journey">Selective Journey</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/what-we-do">What we Do</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/faqs">Have Questions</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/contact-us">Get in Touch</Link>
            </li>
            <li className="nav-item login-item">
              <Link className="font-semibold bg-teal-500 px-6 py-3 rounded-md text-center text-white hover:bg-purple-500" to="/login" onClick={handleLinkClick}>Log In/Sign up</Link>
            </li>
          </>
        )}
      </ul>
      {isDropdownOpen && (
        <ul className="mobile-navbar-nav">
          {/* Use same links as in navbar-nav, but styled for mobile */}
          {userRole === 'admin' ? (
            <>
              <li className="drawer-item"><Link className="drawer-link" to="/admin-dashboard" onClick={handleLinkClick}>Home</Link></li>
              <li className="drawer-item"><Link className="drawer-link" to="/add-questionsBooks" onClick={handleLinkClick}>Add Questions</Link></li>
              <li className="drawer-item"><Link className="drawer-link" to="/import-questions" onClick={handleLinkClick}>Import Questions</Link></li>
              <li className="drawer-item"><Link className="drawer-link" to="/manage-access" onClick={handleLinkClick}>Manage Students</Link></li>
              <li className="drawer-item"><Link className="drawer-link" to="/coupon-management" onClick={handleLinkClick}>Manage Coupon</Link></li>
              <li className="drawer-item"><Link className="drawer-link" to="/admin/add-teacher" onClick={handleLinkClick}>Manage Teachers</Link></li>
              <li className="drawer-item"><Link className="drawer-link" to="/admin/writing-tests" onClick={handleLinkClick}>Assign Writings</Link></li>
              
              
              <li className="drawer-item">
                <button className="font-semibold bg-red-600 px-6 py-3 rounded-md text-white w-full hover:bg-red-500" onClick={handleLogout}>Logout</button>
              </li>
            </>
          ) : userRole === 'student' ? (
            <>
              <li className="drawer-item"><Link className="drawer-link" to="/new-student-dashboard" onClick={handleLinkClick}>Student Dashboard</Link></li>
              <li className="drawer-item"><Link className="drawer-link" to="/profile" onClick={handleLinkClick}>My Profile</Link></li>
              <li className="drawer-item">
                <button className="font-semibold bg-red-600 px-6 py-3 rounded-md text-white w-full hover:bg-red-500" onClick={handleLogout}>Logout</button>
              </li>
            </>
          ) : (
            <>
              <li className="drawer-item"><Link className="drawer-link" to="/landing" onClick={handleLinkClick}>Home</Link></li>
              <li className="drawer-item"><Link className="drawer-link" to="/oc-journey" onClick={handleLinkClick}>OC Journey</Link></li>
              <li className="drawer-item"><Link className="drawer-link" to="/selective-journey" onClick={handleLinkClick}>Selective Journey</Link></li>
              <li className="drawer-item"><Link className="drawer-link" to="/what-we-do" onClick={handleLinkClick}>What we Do</Link></li>
              <li className="drawer-item"><Link className="drawer-link" to="/faqs" onClick={handleLinkClick}>Have Questions</Link></li>
              <li className="drawer-item"><Link className="drawer-link" to="/contact-us" onClick={handleLinkClick}>Get in Touch</Link></li>
              <li className="drawer-item login-item">
                <Link className="font-semibold bg-teal-500 px-6 py-3 rounded-md text-white w-full hover:bg-purple-500" to="/login"  onClick={handleLinkClick}>Log In/Sign up</Link>
              </li>
            </>
          )}
        </ul>
      )}

    </nav>
  );
}

export default Navbar;